/**
 * CardButtonContainer component.
 */
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled card horizontal button container.
 */
const CardButtonContainer = styled.div<{
  active?: boolean;
  color?: string;
  pill?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background: ${(props) => {
    return props?.pill || !props?.active ? '#090909CC' : '#FFFFFFCC';
  }};
  border: ${(props) => {
      if (props?.pill) return props?.color || '#FFFFFF';
      return props?.active
        ? props?.color || '#09090933'
        : props?.color || '#FFFFFF';
    }}
    solid ${2 * Screen.widthRatio}px;
  border-radius: ${20 * Screen.widthRatio}px;
  color: ${(props) => (props.active && !props.pill ? '#000000' : '#FFFFFF')};
  font-family: ${Fonts['regular']};
  font-size: ${20 * Screen.widthRatio}px;
  right: ${8 * Screen.widthRatio}px;
  ${(props) =>
    props?.pill
      ? `
    gap: ${8 * Screen.widthRatio}px;
    height: ${35 * Screen.widthRatio}px;
    width: ${221.35 * Screen.widthRatio}px;
  `
      : `
    height: ${30 * Screen.widthRatio}px;
    width: ${30 * Screen.widthRatio}px;
  `}
`;

export default CardButtonContainer;
